import styled from 'styled-components'

export const WebinarsPageContainer = styled.main`
  padding: 24px 16px 48px;
  max-width: 1200px;
  margin: 0 auto;
  font-family: Outfit, sans-serif;

  @media (min-width: 768px) {
    padding: 32px 24px 64px;
  }
`

export const WebinarsPageTitle = styled.h1`
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.03em;
  color: #1a0a4e;
  margin: 0 0 8px 0;
  line-height: 1.2;

  .dark-theme & {
    color: rgba(255, 255, 255, 0.95);
  }

  @media (min-width: 768px) {
    font-size: 32px;
    margin-bottom: 12px;
  }
`

export const WebinarsPageSubtitle = styled.p`
  font-size: 15px;
  font-weight: 400;
  color: #5c5c7a;
  margin: 0 0 32px 0;
  line-height: 1.5;

  .dark-theme & {
    color: rgba(255, 255, 255, 0.7);
  }

  @media (min-width: 768px) {
    font-size: 16px;
    margin-bottom: 40px;
  }
`

export const WebinarsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;

  @media (min-width: 560px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }

  @media (min-width: 900px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 28px;
  }
`

export const WebinarCardWrapper = styled.article`
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  box-shadow: 0 4px 24px rgba(32, 7, 105, 0.08);
  border: 1px solid rgba(32, 7, 105, 0.08);
  transition: transform 0.2s ease, box-shadow 0.25s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 40px rgba(32, 7, 105, 0.15);
  }

  .dark-theme & {
    background: rgba(37, 38, 42, 0.85);
    border-color: rgba(255, 255, 255, 0.08);
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
  }

  .dark-theme &:hover {
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
  }
`

export const WebinarCardImage = styled.div`
  position: relative;
  aspect-ratio: 16 / 10;
  background: linear-gradient(135deg, #e3ebff 0%, #d4d0e8 100%);
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      to top,
      rgba(26, 10, 78, 0.7) 0%,
      rgba(26, 10, 78, 0.2) 40%,
      transparent 70%
    );
    pointer-events: none;
  }
`

export const WebinarCardImageImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;

  ${WebinarCardWrapper}:hover & {
    transform: scale(1.05);
  }
`

export const WebinarCardTag = styled.span`
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  z-index: 1;
  backdrop-filter: blur(8px);

  &.popular {
    background: rgba(34, 197, 94, 0.9);
    color: white;
  }

  &.trending {
    background: rgba(249, 115, 22, 0.9);
    color: white;
  }
`

export const WebinarCardContent = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const WebinarCardTitle = styled.h3`
  font-size: 17px;
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.35;
  color: #1a0a4e;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  .dark-theme & {
    color: rgba(255, 255, 255, 0.95);
  }

  @media (min-width: 768px) {
    font-size: 18px;
  }
`

export const WebinarCardCta = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #5f2ec7;
  margin-top: 4px;

  .dark-theme & {
    color: #a78bfa;
  }

  ${WebinarCardWrapper}:hover & {
    text-decoration: underline;
  }
`

export const WebinarsLoadMore = styled.div`
  display: flex;
  justify-content: center;
  padding: 32px 0;
  min-height: 48px;
`
